import { render, staticRenderFns } from "./simulationCase.vue?vue&type=template&id=22c5d7f0&scoped=true&"
import script from "./simulationCase.vue?vue&type=script&lang=js&"
export * from "./simulationCase.vue?vue&type=script&lang=js&"
import style0 from "./simulationCase.vue?vue&type=style&index=0&id=22c5d7f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c5d7f0",
  null
  
)

export default component.exports